export enum ListStyle {
  None = '',
  Compact = 'compact'
}
